import { createApp } from 'vue'
import CaseCarousel from './CaseCarousel'

const el = '.kb-component--case-carousel'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((CaseCarouselDOM) => {
            const props = {
                carouselId: CaseCarouselDOM.id,
                contentJson: CaseCarouselDOM.dataset.contentjson
                    ? JSON.parse(CaseCarouselDOM.dataset.contentjson)
                    : [],
                link: CaseCarouselDOM.dataset.link
                    ? JSON.parse(CaseCarouselDOM.dataset.link)
                    : null,
                type: CaseCarouselDOM.dataset.type
            }

            const component = createApp(CaseCarousel, props).use(Store)
            component.mount(CaseCarouselDOM)
        })
    }
}
